import Vue from 'vue';

// initial state
const state = {
  counter: 0
};

const getters = {
  counter: function(state) {
    return state.counter;
  }
};

const mutations = {
  setCounter: function(state, counter) {
    state.counter = counter;
  }
};

const actions = {
  getCounterByCampaignId: function(context, campaignId) {
    Vue.http.get(wwfconfigs.CLOUDFUNCTION + '/' + 'getCounterByCampaignId?campaignId=' + campaignId).then(response => {
      context.commit('setCounter', response.body.count);
    });
  },
  getContentMessageById: function(context, id) {
    return Vue.http.get(wwfconfigs.CLOUDFUNCTION + '/' + 'getContentMessageById?messageId=' + id).then(response => response.body);
  },
  saveLead: function(context, data) {
    return Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + 'saveLead', data);
  },
  savePartnershipForm: function(context, data) {
    return Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + 'savePartnershipForm', data);
  },
  checkEmail: function (context, data) {
    if (!data.email || data.email.length === 0 || !data.email.includes('@')) {
      return false;
    }
    
    // Check if the mail already exist for this particular campaign
    return Vue.http.post(`${wwfconfigs.CLOUDFUNCTION}/checkEmailForCampaign?campaignId=${data.campaignId}&email=${data.email}`)
      .then(response => {
        return response.body.exist;
      }, 
        error => {
          console.error(error);
          return false;
        }
      );
  },
  getEPBCRecipients: function (context, data) {
    return Vue.http.post(`${wwfconfigs.CLOUDFUNCTION}/epbcGetRecipients?postcode=${data.postcode}`)
      .then(response => {
        return response.body;
      }, 
        error => {
          console.error(error);
          return false;
        }
      );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign.js